"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_transition_group_1 = require("react-transition-group");
var Rednot = function (props) {
    var nodeRef = react_1.default.useRef(null);
    var componentClassName = props.componentClassName, timeout = props.timeout, CustomComponent = props.CustomComponent;
    var notifications = react_redux_1.useSelector(function (state) { return state.rednot; });
    var renderedNotifications = notifications.map(function (n) {
        var innerComponent = react_1.default.createElement("div", { className: n.className || 'rednot--notification' }, n.message);
        if (CustomComponent) {
            innerComponent = react_1.default.createElement(CustomComponent, { notification: n });
        }
        return (react_1.default.createElement(react_transition_group_1.CSSTransition, { nodeRef: nodeRef, in: true, key: n.id, classNames: componentClassName, timeout: timeout || 600 },
            react_1.default.createElement("div", { ref: nodeRef }, innerComponent)));
    });
    return (react_1.default.createElement("div", { className: componentClassName + "--container" },
        react_1.default.createElement(react_transition_group_1.TransitionGroup, null, renderedNotifications)));
};
Rednot.defaultProps = {
    componentClassName: 'rednot',
    CustomComponent: null,
    timeout: 600,
};
Rednot.propTypes = {
    componentClassName: prop_types_1.default.string,
    CustomComponent: prop_types_1.default.oneOfType([prop_types_1.default.func, prop_types_1.default.node, prop_types_1.default.element]),
    timeout: prop_types_1.default.number,
};
exports.default = Rednot;
//# sourceMappingURL=Rednot.js.map